module.exports = __webpack_public_path__ + "static/media/buyer-req-workspace-help-3.9f609d6d.svg";